<template>
  <b-container fluid style="z-index: 4!important;">
    <b-row align-h="center" class="mb-3 mt-4">
      <b-col lg="12">
        <b-row align-h="between" class="top-shelf-client py-3">
          <b-col lg="1" cols="12" class="mb-2 mb-lg-0 align-self-start">
            <b-link class="ml-1 ml-lg-3" @click="$router.push(goBackRoute)" style="color: #1d58b7;">
              <font-awesome-icon :icon="['far', 'arrow-left']" size="lg" />
            </b-link>
          </b-col>
          <b-col lg="7" cols="12">
            <b-row class="mx-0">
              <b-col style="flex: 0 0 50px" class="pl-0">
                <div class="title-badge-icon">
                  <font-awesome-icon :icon="['fas', 'industry-alt']" size="2x" fixed-width />
                </div>
              </b-col>
              <b-col class="pl-5">
                <b-row align-h="between" class="title-badge-text-top pr-2">
                  <span>{{ isLoading ? 'cargando...' : ready ? subTitle : 'error' }}</span>
                </b-row>
                <b-row class="title-badge-text-bottom">
                  <div style="word-wrap: break-word">
                    {{ isLoading ? 'cargando...' : ready ? title : 'error' }}
                  </div>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="4" cols="12" class="text-right">
            <slot name="actions"></slot>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: 'Header',
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    },
    goBackRoute: {
      type: String,
      required: false,
      default: '/app/prod/clientes'
    },
    ready: {
      type: Boolean,
      required: true,
      default: false
    },
    isLoading: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.top-shelf-client {
  display: flex;
  justify-content: center;
  align-items: center;
  // border: 2px solid #e2e8f0;
  // border-radius: 10px;

  @media (max-width: 767.98px) {
    border: 2px solid #e2e8f0;
    border-radius: 10px;
  }
}
.title-badge-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: #1d58b7;
  border-radius: 5px;
  width: 50px;
  height: 50px;
}

.title-badge-text-top {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 0;
  color: #ff9900;
}

.title-badge-text-bottom {
  font-family: 'Lato', sans-serif;
  line-height: 25px;
  // font-weight: 600;
  color: #4c4e51;
  font-size: 20px;
  margin-bottom: 0;
}

@media (max-width: 767.98px) {
  .title-badge-text-top {
    font-size: 16px;
  }
  .title-badge-text-bottom {
    font-size: 18px;
  }
}
</style>
